module.exports = __webpack_public_path__ + "static/media/phone.18475a46.svg";